<p-dialog class="custom-dialog"
  [header]="getHeader()"
  [(visible)]="visible"
  [style]="{ width: '100%', maxWidth: '1000px' }"
  [contentStyle]="{ minHeight: 'calc(100vh - 750px)' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [focusOnShow]="false"
>
  <div class="flex flex-column gap-3">
    <eo-form
      #eoForm
      [config]="getFormConfig()"
      (formSubmit)="onSubmit($event)"
      [submitButtonLoading]="isSubmitLoading()"
      [submitButtonStyleClass]="'p-button-sm p-button-primary'"
    />
  </div>
</p-dialog>
